import { PERMISSIONS } from "../../../store/userStore/permissions.enum";
import { IconButton } from "@material-ui/core";
import FAIcon from "../../Shared/MapPreview/images/freqAnalysis.svg";
import { CheckPermission } from "../../../requests/CheckPermission";
import { pagePathGenerator } from "../../../routes/pagePathGenerator";
import { useHistory } from "react-router-dom";
import FrequencyAnalysisPage from "../../../pages/FrequencyAnalysisPage";

interface FrequencyAnalysisLinkIconProps {
  deviceIdList?: number[],
  mapId?: number,
  disabled?: boolean,
}

const FrequencyAnalysisLinkIcon = ({ disabled = false, deviceIdList, mapId }: FrequencyAnalysisLinkIconProps) => {
  const history = useHistory();
  const url = pagePathGenerator.FREQUENCY_ANALYSIS({ mapId });
  const iconIsDisabled = disabled || (!mapId && (!deviceIdList || deviceIdList.length === 0))

  const onFrequencyAnalysisClick = () => {
    if (!mapId && deviceIdList) {
      FrequencyAnalysisPage.saveDeviceIdListToStorage(deviceIdList);
    }
    history.push(url);
  }

  return (
    <CheckPermission permissionName={PERMISSIONS.FREQUENCY_ANALYSIS_ACCESS} noPermissionComponent={null}>
      <IconButton
        disabled={iconIsDisabled}
        component="span"
        color="secondary"
        size="small"
        onClick={onFrequencyAnalysisClick}
      >
        <img
          src={FAIcon}
          alt={'Frequency Analysis'}
        />
      </IconButton>
    </CheckPermission>
  );
}

export default FrequencyAnalysisLinkIcon;